module.exports = __webpack_public_path__ + "static/media/icon-nav-user.46dcb523.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-nav-user.svg
// module id = 1216
// module chunks = 19